"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SWITCH_BUTTON = exports.IS_TABLET = exports.INPUT_LABEL = void 0;
var INPUT_LABEL = 'Browse cities by using the up and down arrows and select by pressing enter.';
exports.INPUT_LABEL = INPUT_LABEL;
var SWITCH_BUTTON = 'Switch Button';
exports.SWITCH_BUTTON = SWITCH_BUTTON;
var IS_TABLET = 'tablet';
exports.IS_TABLET = IS_TABLET;